import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import PropTypes from "prop-types";
import { getSourceImageUrlToCGI } from "../utils/base";

const Image = ({
  image = null,
  imageAlt,
  imageClass,
  sourceUrl,
  icon = false,
  extraProps
}) => {
  if (image) {
    if (typeof image == "string" && image?.length > 5) {
      return <img src={image} className={imageClass} alt={imageAlt ?? ""} />;
    } else if (typeof image == "object") {
      const displayImage = getImage(image);
      return (
        <>
          {image.extension === "svg" && image.publicURL ? (
            <img
              src={image.publicURL}
              className={imageClass}
              alt={imageAlt ?? ""}
            />
          ) : displayImage && image.extension !== "svg" && !icon ? (
            <GatsbyImage
              {...extraProps}
              className={imageClass}
              image={displayImage}
              alt={imageAlt ?? ""}
            />
          ) : (
            <img
              src={getSourceImageUrlToCGI({
                uri: image?.sourceUrl ?? sourceUrl
              })}
              className={imageClass}
              alt={imageAlt ?? ""}
            />
          )}
        </>
      );
    } else {
      return null;
    }
  } else if (sourceUrl) {
    // console.debug('image sourceUrl', {sourceUrl})
    return (
      <img
        src={getSourceImageUrlToCGI({ uri: sourceUrl })}
        className={imageClass}
        alt={imageAlt ?? ""}
      />
    );
  } else return null;
};

Image.defaultProps = {
  image: null,
  icon: false,
  extraProps: {
    loading: "lazy",
    as: "div",
    style: "",
    imgStyle: "",
    backgroundColor: "transparent"
  }
};

Image.propTypes = {
  extraProps: PropTypes.object,
  image: PropTypes.any,
  icon: PropTypes.bool
};
export default Image;
